<template>
  <div class="animated fadeIn">
    <b-card>
      <div slot="header">
        {{ this.$route.meta.title }}
        <div class="card-header-actions">
          <!-- <button
            class="btn btn-primary mr-1"
            @click="showFilter = !showFilter"
          >
            <i class="fa fa-filter"></i> Filter
          </button> -->
          <button class="btn btn-primary mr-1" @click="close()">
            <i class="fa fa-close"></i> {{ $t("close") }}
          </button>
        </div>
      </div>
      <b-row>
        <b-col lg="10">
          <b-input-group>
            <b-input-group-prepend > 
              <label style="min-width: 150px">Periode</label>
            </b-input-group-prepend>
            <vue-monthly-picker v-model="model.periode" dateFormat="MMMM YYYY" 
              :monthLabels="monthLabels" @selected="onChangeMonth" 
              :state="!$v.model.periode.$error"
              :max="maxdtreport"></vue-monthly-picker>
            <b-input-group-append>
              <b-button
                variant="success"
                @click="getAP()"
                class="ml-3"
              >
                <i class="fa fa-play"></i> Proses
              </b-button>
              <b-button variant="primary ml-2" @click="exportxlsAP()">
                <i class="fa fa-file-excel-o"></i>Export
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </b-col>
      </b-row>
      <b-card no-body class="mb-0">
        <b-table
          class="mb-0"
          ref="table"
          outlined
          responsive
          striped
          hover
          style="font-size: smaller"
          :items="tblData.items"
          :fields="tblFields"
          :current-page="tblData.page"
          :per-page="tblData.limit"
          :sort-by.sync="tblData.sortBy"
          :sort-desc.sync="tblData.sortDesc"
          :key="tblData.limit"
                :filter="filterInput"
                :filterIncludedFields="filterOn"
                @filtered="onFiltered"                
          :busy="isBusy"
          show-empty
        >
          <template v-slot:cell(index)="data">{{((tblData.page-1)*tblData.limit)+( data.index + 1) }}</template>
          <template v-slot:cell(duedate)="data">{{
            data.item.duedate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(tgl_kontrak)="data">{{
            data.item.tgl_kontrak | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(startdate)="data">{{
            data.item.startdate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(EffectiveRatePercentage)="data">{{
            data.item.EffectiveRatePercentage | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month13_installment)="data">{{
            data.item.month13_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month13_pokok)="data">{{
            data.item.month13_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month13_bunga)="data">{{
            data.item.month13_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month46_installment)="data">{{
            data.item.month46_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month46_pokok)="data">{{
            data.item.month46_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month46_bunga)="data">{{
            data.item.month46_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month712_installment)="data">{{
            data.item.month712_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month712_pokok)="data">{{
            data.item.month712_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month712_bunga)="data">{{
            data.item.month712_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(InstallmentMonth13_24)="data">{{
            data.item.InstallmentMonth13_24 | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month1324_pokok)="data">{{
            data.item.month1324_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month1324_bunga)="data">{{
            data.item.month1324_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month2536_installment)="data">{{
            data.item.month2536_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month2536_pokok)="data">{{
            data.item.month2536_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month2536_bunga)="data">{{
            data.item.month2536_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month3748_installment)="data">{{
            data.item.month3748_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month3748_pokok)="data">{{
            data.item.month3748_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month3748_bunga)="data">{{
            data.item.month3748_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month4960_installment)="data">{{
            data.item.month4960_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month4960_pokok)="data">{{
            data.item.month4960_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month4960_bunga)="data">{{
            data.item.month4960_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month6172_installment)="data">{{
            data.item.month6172_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month6172_pokok)="data">{{
            data.item.month6172_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month6172_bunga)="data">{{
            data.item.month6172_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month7384_installment)="data">{{
            data.item.month7384_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month7384_pokok)="data">{{
            data.item.month7384_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month7384_bunga)="data">{{
            data.item.month7384_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month8596_installment)="data">{{
            data.item.month8596_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month8596_pokok)="data">{{
            data.item.month8596_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month8596_bunga)="data">{{
            data.item.month8596_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month97108_installment)="data">{{
            data.item.month97108_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month97108_pokok)="data">{{
            data.item.month97108_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month97108_bunga)="data">{{
            data.item.month97108_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month109120_installment)="data">{{
            data.item.month109120_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month109120_pokok)="data">{{
            data.item.month109120_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month109120_bunga)="data">{{
            data.item.month109120_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month120_installment)="data">{{
            data.item.month120_installment | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month120_pokok)="data">{{
            data.item.month120_pokok | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(month120_bunga)="data">{{
            data.item.month120_bunga | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(UCI)="data">{{
            data.item.UCI | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(DaysOverdue)="data">{{
            data.item.DaysOverdue | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket1GrossAmt)="data">{{
            data.item.Bucket1GrossAmt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket1PrincipleAmt)="data">{{
            data.item.Bucket1PrincipleAmt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket2GrossAmt)="data">{{
            data.item.Bucket2GrossAmt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket2PrincipleAmt)="data">{{
            data.item.Bucket2PrincipleAmt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket3GrossAmt)="data">{{
            data.item.Bucket3GrossAmt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket3PrincipleAmt)="data">{{
            data.item.Bucket3PrincipleAmt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(principal_outstand)="data">{{
            data.item.principal_outstand | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket4GrossAmt)="data">{{
            data.item.Bucket4GrossAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(saldo_interest)="data">{{
            data.item.saldo_interest | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket4PrincipleAmt)="data">{{
            data.item.Bucket4PrincipleAmt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket5GrossAmt)="data">{{
            data.item.Bucket5GrossAmt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket5PrincipleAmt)="data">{{
            data.item.Bucket5PrincipleAmt | numFormat("0,0.00")
          }}</template>
          <template v-slot:cell(Bucket6GrossAmt)="data">{{
            data.item.Bucket6GrossAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Bucket6PrincpleAmt)="data">{{
            data.item.Bucket6PrincpleAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Bucket7GrossAmt)="data">{{
            data.item.Bucket7GrossAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Bucket7PrincipleAmt)="data">{{
            data.item.Bucket7PrincipleAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Bucket8GrossAmt)="data">{{
            data.item.Bucket8GrossAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Bucket8PrincpleAmt)="data">{{
            data.item.Bucket8PrincpleAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Bucket9GrossAmt)="data">{{
            data.item.Bucket9GrossAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Bucket9PrincipleAmt)="data">{{
            data.item.Bucket9PrincipleAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Bucket10GrossAmt)="data">{{
            data.item.Bucket10GrossAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(Bucket10PrincipleAmt)="data">{{
            data.item.Bucket10PrincipleAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OSPrincipalAmount)="data">{{
            data.item.OSPrincipalAmount | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OSInterestAmount)="data">{{
            data.item.OSInterestAmount | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OSPrincipalUndueAmount)="data">{{
            data.item.OSPrincipalUndueAmount | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OSInterestUndueAmount)="data">{{
            data.item.OSInterestUndueAmount | numFormat("0,0")
          }}</template>
          <template v-slot:cell(ContractPrepaidAmt)="data">{{
            data.item.ContractPrepaidAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(LCInstallmentAmt)="data">{{
            data.item.LCInstallmentAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(LCInstallmentPaidAmt)="data">{{
            data.item.LCInstallmentPaidAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(InstallmentDueAmt)="data">{{
            data.item.InstallmentDueAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(InstallmentDuePaidAmt)="data">{{
            data.item.InstallmentDuePaidAmt | numFormat("0,0")
          }}</template>

          <template v-slot:cell(WODt)="data">{{
            data.item.WODt | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(NextInstallmentDt)="data">{{
            data.item.NextInstallmentDt | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(NextInstallmentDueDt)="data">{{
            data.item.NextInstallmentDueDt | moment("DD/MM/YY")
          }}</template>

          <template v-slot:cell(InstallmentDueOffAmt)="data">{{
            data.item.InstallmentDueOffAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OSPrincipalUndueOffAmt)="data">{{
            data.item.OSPrincipalUndueOffAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(OSInterestUndueOffAmt)="data">{{
            data.item.OSInterestUndueOffAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(InstallmentDuePaidOffAmt)="data">{{
            data.item.InstallmentDuePaidOffAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(FeeChargeRcvAmt)="data">{{
            data.item.FeeChargeRcvAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(FeeChargeRcvPaidAmt)="data">{{
            data.item.FeeChargeRcvPaidAmt | numFormat("0,0")
          }}</template>
          <template v-slot:cell(NTFAmount)="data">{{
            data.item.NTFAmount | numFormat("0,0")
          }}</template>
          <template v-slot:cell(InstallmentAmount)="data">{{
            data.item.InstallmentAmount | numFormat("0,0")
          }}</template>

          <template v-slot:cell(LastPaymentDate)="data">{{
            data.item.NextInstallmentDueDt | moment("DD/MM/YY")
          }}</template>

          <template v-slot:cell(interest)="data">{{
            data.item.interest | numFormat("0,0")
          }}</template>
          <template v-slot:cell(TotalAR)="data">{{
            data.item.TotalAR | numFormat("0,0")
          }}</template>
          <template v-slot:cell(TotalOverdue)="data">{{
            data.item.TotalOverdue | numFormat("0,0")
          }}</template>
          <template v-slot:cell(NextInstallmentAmount)="data">{{
            data.item.NextInstallmentAmount | numFormat("0,0")
          }}</template>

          <template v-slot:cell(NextInstallmentDate)="data">{{
            data.item.NextInstallmentDate | moment("DD/MM/YY")
          }}</template>
          <template v-slot:cell(NextInstallmentDueDate)="data">{{
            data.item.NextInstallmentDueDate | moment("DD/MM/YY")
          }}</template>

          <template v-slot:cell(OS_PRINCIPAL_TOTAL_AMT)="data">{{
            data.item.OS_PRINCIPAL_TOTAL_AMT | numFormat("0,0.00")
          }}</template>

          <template v-slot:cell(OS_INTEREST_TOTAL_AMT)="data">{{
            data.item.OS_INTEREST_TOTAL_AMT | numFormat("0,0.00")
          }}</template>

          <template v-slot:cell(UCI_lancar)="data">{{
            data.item.UCI_lancar | numFormat("0,0.00")
          }}</template>


          <template v-slot:table-busy>
            <div class="text-center text-danger my-2">
              <b-spinner class="align-middle"></b-spinner>
              <strong>Loading...</strong>
            </div>
          </template>
          <template v-slot:cell(empty)="data">
            <h4>{{ data.emptyText }}</h4>
          </template>
          <template v-slot:cell(emptyfiltered)="data">
            <h4>{{ data.emptyFilteredText }}</h4>
          </template>
          
        </b-table>
      </b-card>
              <b-row class="m-1">
                <b-col lg="6">            
                  <b-row v-if="(filterShow=='Hide')">
                        <b-input-group size="sm">
                            <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch></b-form-checkbox>
                            <b-input-group-prepend> <span class="pr-2">
                                <b> {{ filterShow }}</b>  Filter </span>
                            </b-input-group-prepend>
                            <b-form-input v-model="filter" type="search" placeholder="Type to Search"></b-form-input>
                            <b-input-group-append>
                                <b-button :disabled="!filter" @click="filter = ''">Clear</b-button>
                            </b-input-group-append>
                        </b-input-group>
                        <b-input-group size="sm" class="ml-4">
                    <b-input-group-prepend class="ml-5"> <span class="pr-2">On</span>
                        </b-input-group-prepend>
                        <b-form-checkbox-group v-model="filterOn" class="mt-1">
                          <b-form-checkbox value="no_agreement">Agreement No.</b-form-checkbox>
                          <b-form-checkbox value="CustName">Debitur Name</b-form-checkbox>
                          <b-form-checkbox value="KOL_EOM">Collectability</b-form-checkbox>
                          <b-form-checkbox value="DefaultStat">Default (WO) status</b-form-checkbox>
                        </b-form-checkbox-group>
                    </b-input-group>
                    <label class="text-muted small" style="margin-left:100px;">Leave all unchecked to filter on all data</label>
              </b-row>
                  <b-row v-else>
                    <b-form-checkbox v-model="filterShow" value="Hide" unchecked-value="Show" switch >
                      <b> {{ filterShow }}</b>  Filter
                    </b-form-checkbox>
                  </b-row>
                </b-col>
                <b-col lg="6">
                  <div style="display: flex;margin:0;padding:0;">
                      <div style="margin:0;padding:5px;width:500px; text-align:right;">
                          Showing {{(tblData.page - 1) * tblData.limit + 1}}
                          to <span v-if="((tblData.page * tblData.limit)>tblData.total)">{{tblData.total}}</span> <span v-else>{{tblData.page * tblData.limit}}</span>
                          of {{tblData.total}} ,   <span class="mr-1">limit per page :</span> 
                          <select  v-model="tblData.limit"  style="width:60px;">
                            <option>10</option>
                            <option>15</option>
                            <option>20</option>                            
                            <option>25</option>
                            <option>30</option>                            
                            <option>40</option>                            
                            <option>50</option>                            
                            <option>60</option>                            
                            <option>70</option>                            
                            <option>80</option>                            
                            <option>90</option>                            
                          </select>
                      </div>
                      <div>
                          <b-pagination  class="ml-1" 
                            align="left"
                            :total-rows="tblData.total"
                            :per-page="tblData.limit"
                            v-model="tblData.page"
                          ></b-pagination>
                      </div>
                  </div>
                </b-col>
              </b-row>
    </b-card>
    <loading :active.sync="isBusy" :height="128" :width="128" color="#4b8cf4" ></loading>       
  </div>
</template>

<script>
import Loading from "vue-loading-overlay";
import "vue-loading-overlay/dist/vue-loading.css";
import moment from "moment";
import dropdown from "../../data/dropdown";
import toastr from "mini-toastr";
import pinjaman from "../../apis/pinjamankredit";
import { validationMixin } from "vuelidate";
import { required } from "vuelidate/lib/validators";
import VueMonthlyPicker from 'vue-monthly-picker';

toastr.init();
export default {
  components: { VueMonthlyPicker, Loading },
  mixins: [validationMixin],
  validations: {
    model: {
        periode: { required },
    },
  },
  data() {
    return {
      maxdtreport : moment(this.$store.state.timeServer).subtract(1,'days').format('YYYY-MM-DD'),
      showFilter: true,
      isBusy: false,
      tblData: {
        items: [],
        page: 1,
        limit: 15,
        total: 0,
        sortBy: "no_kontrak",
        sortDesc: false,
        date:'',
        
      },
      isLoading:false,
      monthLabels:dropdown.monthLabels,
      model: {date:'',periode:moment().format('YYYY-MM-DD')},
      filterShow:'Show',
      filter: null,
      filterInput: null,
      filterOn: ['no_agreement','CustName'],  

    };
  },
  computed: {
    invalidFilter() {
      this.$v.model.$touch();
      return this.$v.model.$invalid;
    },
    tblFields() {
      const fields = [
        {
          key: "index",
          label: "#",
          thStyle: "width:140px",
        },
        {
          key: "no_agreement",
          label: "Agreement No",
          thStyle: "width:140px",
          sortable: true,
        },
        {
            key: "CustName",
            label: "Customer Name",
            thStyle: "width:140px",
            sortable: true,
        },
        {
            key: "tgl_kontrak",
            label: "GO Live Date",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "startdate",
            label: "Effective Date",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month13_installment",
            label: "Installment Month 1 - 3",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month13_pokok",
            label: "Principal Month 1 - 3",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month13_bunga",
            label: "Interest Month 1 - 3",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month46_installment",
            label: "Installment Month 4 - 6",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month46_pokok",
            label: "Principal Month 4 - 6",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month46_bunga",
            label: "Interest Month 4 - 6",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month712_installment",
            label: "Installment Month 7 - 12",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month712_pokok",
            label: "Principal Month 7 - 12",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month712_bunga",
            label: "Interest Month 7 - 12",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "InstallmentMonth13_24",
            label: "Installment Month 13 - 24",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month1324_pokok",
            label: "Principal Month 13 - 24",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month1324_bunga",
            label: "Interest Month 13 - 24",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month2536_installment",
            label: "Installment Month 25 - 36",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month2536_pokok",
            label: "Principal Month 25 - 36",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month2536_bunga",
            label: "Interest Month 25 - 36",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month3748_installment",
            label: "Installment Month 37 - 48",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month3748_pokok",
            label: "Principal Month 37 - 48",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month3748_bunga",
            label: "Interest Month 37 - 48",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month4960_installment",
            label: "Installment Month 49 - 60",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month4960_pokok",
            label: "Principal Month 49 - 60",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month4960_bunga",
            label: "Interest Month 49 - 60",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month6172_installment",
            label: "Installment Month 61 - 72",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month6172_pokok",
            label: "Principal Month 61 - 72",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month6172_bunga",
            label: "Interest Month 61 - 72",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month7384_installment",
            label: "Installment Month 73 - 84",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month7384_pokok",
            label: "Principal Month 73 - 84",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month7384_bunga",
            label: "Interest Month 73 - 84",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month8596_installment",
            label: "Installment Month 85 - 96",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month8596_pokok",
            label: "Principal Month 85 - 96",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month8596_bunga",
            label: "Interest Month 85 - 96",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month97108_installment",
            label: "Installment Month 97 - 108",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month97108_pokok",
            label: "Principal Month 97 - 108",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month97108_bunga",
            label: "Interest Month 97 - 108",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month109120_installment",
            label: "Installment Month 109 - 120",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month109120_pokok",
            label: "Principal Month 109 - 120",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month109120_bunga",
            label: "Interest Month 109 - 120",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month120_installment",
            label: "Installment Month > 120",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month120_pokok",
            label: "Principal Month > 120",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
            key: "month120_bunga",
            label: "Interest Month > 120",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },
        {
          key: "OS_PRINCIPAL_TOTAL_AMT",
          label: "OS_PRINCIPAL_TOTAL_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },
        {
          key: "OS_INTEREST_TOTAL_AMT",
          label: "OS_INTEREST_TOTAL_AMT",
          thStyle: "width:140px",
          thClass: "text-center",
          tdClass: "text-right",
          sortable: true,
        },

        {
            key: "UCI_lancar",
            label: "Uci Amount",
            thStyle: "width:140px",
            thClass: "text-center",
            tdClass: "text-right",
            sortable: true,
        },

      ];
      return fields;
    },
    dimCol() {
      return this.tblData.DimCol;
    },
  },
  watch:{
    filterShow: function(newval) {
      setTimeout(() => {
              this.filter=''
      }, 200);
    },
    filter: function(newval) {
      // this.isBusy=true;
      setTimeout(() => {
            this.filterInput=newval;
      }, 800);
    },
  },  
  async created() {
    this.model.periode = moment(this.$store.state.user.tglaktif, 'YYYY-MM-DD');
    this.model.date=moment(this.model.periode).endOf('month').format('YYYY-MM-DD');
  },
  methods: {
    onFiltered(filteredItems) {
      this.tblData.total = filteredItems.length;
      this.tblData.page = 1;
    },     
    clearFilter() {
          // this.filterOn= []   
          this.filter= '';   
    } ,

    onChangeMonth: async function (){
        var tgl=this.model.periode;
        this.model.date=moment(tgl).endOf('month').format('YYYY-MM-DD');
        this.$forceUpdate();
    }, 
    async getAP() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        try {
            this.isBusy = true;
            const result = await pinjaman.APreport_wo30sep19(this.model);
            this.isBusy = false;
            this.tblData.items = result;
            this.tblData.total = result.length;
            this.isBusy = false;
        } catch (error) {
            this.isLoading=false;
            if (error.message) {
                toastr.error(error.message,'Error Info',10000);
            } else {
                toastr.error(JSON.stringify(error),'Error Info',10000);
            }
        }
       }
    },
    async exportxlsAP() {
      if (this.invalidFilter) {
            toastr.error('Please fill the form correctly.');
       } else {
        try {
          this.isBusy = true;
          await pinjaman.exportxlsAP_wo30sep19(this.model);
          this.isBusy = false;
        } catch (error) {
          this.isBusy = false;
          if (error.message) {
            toastr.error(error.message, "ERROR MESSAGE", 10000);
          } else {
            toastr.error(JSON.stringify(error), "ERROR MESSAGE", 10000);
          }
        }
      }
    },
    close() {
      router.push("home");
    },
  },
};
</script>